import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@mui/material';

export default function DeleteConfirmDialog({
  openDeleteDialog,
  deleteType,
  deleteIndex,
  setOpenDeleteDialog,
  setDeleteType,
  setDeleteIndex,
  deleteDatePicker,
  deleteTimePicker,
}) {
  const handleConfirmDelete = () => {
    if (deleteType === 'date' && deleteIndex !== null) {
      deleteDatePicker(deleteIndex);
    } else if (deleteType === 'time' && deleteIndex !== null) {
      deleteTimePicker(deleteIndex);
    }
    setOpenDeleteDialog(false);
    setDeleteType('');
    setDeleteIndex(null);
  };

  const handleCancelDelete = () => {
    setOpenDeleteDialog(false);
    setDeleteType('');
    setDeleteIndex(null);
  };

  return (
    <Dialog
      open={openDeleteDialog}
      onClose={handleCancelDelete}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogContent>
        <Typography
          sx={{
            color: 'var(--clr-theme-gray)',
            fontFamily: 'Karla',
            fontWeight: 700,
            textAlign: 'center',
          }}
        >
          Are you sure you want to delete this {deleteType}?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={handleCancelDelete}
          color='primary'
          sx={{
            color: 'var(--clr-theme-purple)',
            border: '1px solid var(--clr-theme-purple)',
          }}
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          onClick={handleConfirmDelete}
          color='error'
          autoFocus
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
} 